import React, { useEffect, useRef, useState } from "react";
import hljs from "highlight.js";
import ReactQuill from "react-quill-new";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { createBlogApi, createCaseStudyApi, getBlogCategoriesApi, getBlogTagsApi } from "../../helper/api_helper";
import { Icon } from "@iconify/react/dist/iconify.js";
// import { toast } from "react-toastify";

import toast from "react-hot-toast";
const AddCaseStudy = () => {
    const navigate = useNavigate()
    const [imagePreview, setImagePreview] = useState(null);

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setFormData(prev => ({
                ...prev,
                blog_image: file
            }));

            // Create preview
            const reader = new FileReader();
            reader.onload = (e) => {
                setImagePreview(e.target.result);
            };
            reader.readAsDataURL(file);
        }
    };
    const handleRemoveImage = () => {
        setFormData(prev => ({
            ...prev,
            blog_image: null
        }));
        setImagePreview(null);

        // Reset file input
        const fileInput = document.getElementById('upload-file');
        if (fileInput) {
            fileInput.value = '';
        }
    };
    const quillRef = useRef(null);
    const [value, setValue] = useState(``);
    const [isHighlightReady, setIsHighlightReady] = useState(false);

    const [formData, setFormData] = useState({
        blog_title: '',
        blog_description: '',
        blog_image: null,
        section_images: [] 
    });



    useEffect(() => {
        hljs?.configure({
            languages: [
                "javascript",
                "ruby",
                "python",
                "java",
                "csharp",
                "cpp",
                "go",
                "php",
                "swift",
            ],
        });
    }, []);

    const handleSave = () => {
        const editorContent = quillRef.current.getEditor().root.innerHTML;
        
    };

    const modules = isHighlightReady
        ? {
            syntax: {
                highlight: (text) => hljs?.highlightAuto(text).value,
            },
            toolbar: {
                container: "#toolbar-container", 
            },
        }
        : {
            toolbar: {
                container: "#toolbar-container", // Custom toolbar container
            },
        };

    const formats = [
        "font",
        "size",
        "bold",
        "italic",
        "underline",
        "strike",
        "color",
        "background",
        "script",
        "header",
        "blockquote",
        "code-block",
        "list",
        "indent",
        "direction",
        "align",
        "link",
        "image",
        "video",
        "formula",
    ];

    const [isCategoriesLoading, setIsCategoriesLoading] = useState(false);
    const [categories, setCategories] = useState([]);
    const [blogTags, setBlogTags] = useState([]);


    const [creatingBlog, setCreatingBlog] = useState(false);

    const [isTagsLoading, setIsTagsLoading] = useState(false);

    const getAllBlogCategories = async () => {
        try {
            setIsCategoriesLoading(true);
            const response = await getBlogCategoriesApi();

            setCategories(response.data);

        } catch (error) {
            
            toast.error("Failed to fetch categories");
            setCategories([]);
        } finally {
            setIsCategoriesLoading(false);
        }
    };

    useEffect(() => {
        getAllBlogCategories();
    }, []);

    const getAllBlogTags = async () => {
        try {
            setIsTagsLoading(true);
            const response = await getBlogTagsApi();

            setBlogTags(response.data);

        } catch (error) {
            
            toast.error("Failed to fetch tags");
            setBlogTags([]);
        } finally {
            setIsTagsLoading(false);
        }
    };

    useEffect(() => {
        getAllBlogCategories();
        getAllBlogTags();
    }, []);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleDescriptionChange = (content) => {
        setFormData(prev => ({
            ...prev,
            blog_description: content
        }));
    };

    const createBlog = async () => {
        try {
            setCreatingBlog(true);

            // Create FormData object
            const formDataToSend = new FormData();
            formDataToSend.append('title', formData.blog_title);
            formDataToSend.append('description', formData.blog_description);
            if (formData.blog_image) {
                formDataToSend.append('image_url', formData.blog_image);
            }

            formData.section_images.forEach((image, index) => {
                if (image) {
                    formDataToSend.append(`section_images`, image);
                }
            });

            for (let [key, value] of formDataToSend.entries()) {
                
            }

            const response = await createCaseStudyApi(formDataToSend);

            // More flexible response checking
            // if (response && (response.success || response.status === 'success' || response.data)) {
            toast.success(response.message || "Blog created successfully!");
            navigate("/case-study")
            // Reset form
            setFormData({
                blog_title: '',
                blog_category_id: '',
                blog_tag_ids: [],
                blog_description: '',
                blog_image: null
            });
            setImagePreview(null);

            // Reset file input
            const fileInput = document.getElementById('upload-file');
            if (fileInput) {
                fileInput.value = '';
            }

        } catch (error) {
            if (error?.code === "ERR_NETWORK") {

                toast.error("Image size is too large. Please upload a smaller file.");
            } else {
                
                // toast.error(error || "Something went wrong");
            }
        } finally {
            setCreatingBlog(false);
        }
    };

    // Handle form submission
    const handleSubmit = (e) => {
        e.preventDefault();

        // Basic validation
        if (!formData.blog_title.trim()) {
            toast.error("Please enter blog title");
            return;
        }

        if (!formData.blog_description.trim()) {
            toast.error("Please enter blog description");
            return;
        }
        if (!formData.blog_image) {
            toast.error("Please upload a blog image");
            return;
        }
        createBlog();
    };
    // Remove section by index
    const handleRemoveSection = (index) => {
        setFormData(prev => ({
            ...prev,
            sections: prev.sections.filter((_, i) => i !== index)
        }));
    };

    // Update section title or description
    const handleSectionChange = (index, field, value) => {
        const updatedSections = formData.sections.map((section, i) =>
            i === index ? { ...section, [field]: value } : section
        );
        setFormData(prev => ({
            ...prev,
            sections: updatedSections
        }));
    };


    const handleSectionImageChange = (index, file) => {
        const updatedImages = [...formData.section_images];
        updatedImages[index] = file;
        setFormData(prev => ({
            ...prev,
            section_images: updatedImages
        }));
    };


    return (
        <div className='row gy-4'>
            <div className='col-lg-12'>
                <div className='card mt-24'>
                    <div className='card-header border-bottom'>
                        <h6 className='text-xl mb-0'>Add New Case Study</h6>
                    </div>
                    <div className='card-body p-24'>
                        <form onSubmit={handleSubmit} className='d-flex flex-column gap-20'>
                            <div>
                                <label
                                    className='form-label fw-bold text-neutral-900'
                                    htmlFor='title'
                                >
                                    Title:
                                </label>
                                <input
                                    type='text'
                                    name='blog_title'
                                    className='form-control border border-neutral-200 radius-8'
                                    id='title'
                                    placeholder='Enter Title'
                                    value={formData.blog_title}
                                    onChange={handleInputChange}
                                />
                            </div>


                            <div>
                                <label className='form-label fw-bold text-neutral-900'>
                                    Description
                                </label>
                                <div className='border border-neutral-200 radius-8 overflow-hidden'>
                                    <div className='height-200'>
                                        <div id='toolbar-container'>
                                            <span className='ql-formats'>
                                                <select className='ql-font'></select>
                                                <select className='ql-size'></select>
                                            </span>
                                            <span className='ql-formats'>
                                                <button className='ql-bold'></button>
                                                <button className='ql-italic'></button>
                                                <button className='ql-underline'></button>
                                                <button className='ql-strike'></button>
                                            </span>
                                            <span className='ql-formats'>
                                                <select className='ql-color'></select>
                                                <select className='ql-background'></select>
                                            </span>
                                            <span className='ql-formats'>
                                                <button className='ql-script' value='sub'></button>
                                                <button className='ql-script' value='super'></button>
                                            </span>
                                            <span className='ql-formats'>
                                                <button className='ql-header' value='1'></button>
                                                <button className='ql-header' value='2'></button>
                                                <button className='ql-blockquote'></button>
                                                <button className='ql-code-block'></button>
                                            </span>
                                            <span className='ql-formats'>
                                                <button className='ql-list' value='ordered'></button>
                                                <button className='ql-list' value='bullet'></button>
                                                <button className='ql-indent' value='-1'></button>
                                                <button className='ql-indent' value='+1'></button>
                                            </span>
                                            <span className='ql-formats'>
                                                <button className='ql-direction' value='rtl'></button>
                                                <select className='ql-align'></select>
                                            </span>
                                            <span className='ql-formats'>
                                                <button className='ql-clean'></button>
                                            </span>
                                        </div>

                                        <ReactQuill
                                            ref={quillRef}
                                            theme='snow'
                                            value={formData.blog_description}
                                            onChange={handleDescriptionChange}
                                            modules={modules}
                                            formats={formats}
                                            placeholder='Enter Description...'
                                        />
                                    </div>
                                </div>
                            </div>
                            {formData?.sections?.map((section, index) => (
                                <div
                                    key={index}
                                    className="position-relative border rounded shadow-sm p-3 mb-4 bg-white"
                                >
                                    {/* Section Header with Index and Remove Icon */}
                                    <div className="d-flex justify-content-between align-items-center mb-3">
                                        <h6 className="mb-0 fw-bold text-primary-600">
                                            Section {index + 1}
                                        </h6>
                                        {formData.sections.length > 1 && (
                                            <button
                                                type="button"
                                                className="btn btn-link p-0 text-danger"
                                                title="Remove Section"
                                                onClick={() => handleRemoveSection(index)}
                                            >
                                                <Icon icon="mdi:trash-can-outline" className="text-xl" />
                                            </button>
                                        )}
                                    </div>

                                    {/* Section Title */}
                                    <div className="mb-3">
                                        <label className="form-label text-neutral-900 fw-medium">
                                            Section Title
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control border border-neutral-200 radius-8"
                                            placeholder="Enter section title"
                                            value={section.title}
                                            onChange={(e) =>
                                                handleSectionChange(index, "title", e.target.value)
                                            }
                                        />
                                    </div>

                                    {/* Section Description */}
                                    <div className="mb-3">
                                        <label className="form-label text-neutral-900 fw-medium">
                                            Section Description
                                        </label>
                                        <textarea
                                            className="form-control border border-neutral-200 radius-8"
                                            rows={3}
                                            placeholder="Enter section description"
                                            value={section.description}
                                            onChange={(e) =>
                                                handleSectionChange(index, "description", e.target.value)
                                            }
                                        />
                                    </div>


                                    {/* Section Image Upload */}
                                    <div>
                                        <label className="form-label fw-medium text-neutral-900">Section Image (Optional)  </label>
                                        <div className="upload-image-wrapper">
                                            {formData.section_images[index] ? (
                                                <div className="uploaded-img position-relative h-160-px w-100 border input-form-light radius-8 overflow-hidden border-dashed bg-neutral-50">
                                                    <button
                                                        type="button"
                                                        className="uploaded-img__remove position-absolute top-0 end-0 z-1 text-2xxl line-height-1 me-8 mt-8 d-flex bg-danger-600 w-40-px h-40-px justify-content-center align-items-center rounded-circle"
                                                        onClick={() => handleSectionImageChange(index, null)}
                                                    >
                                                        <Icon icon="radix-icons:cross-2" className="text-2xl text-white" />
                                                    </button>
                                                    <img
                                                        className="w-100 h-100 object-fit-cover"
                                                        src={URL.createObjectURL(formData.section_images[index])}
                                                        alt="Section"
                                                    />
                                                </div>
                                            ) : (
                                                <label
                                                    className="upload-file h-160-px w-100 border input-form-light radius-8 overflow-hidden border-dashed bg-neutral-50 bg-hover-neutral-200 d-flex align-items-center flex-column justify-content-center gap-1"
                                                    htmlFor={`section-image-${index}`}
                                                >
                                                    <iconify-icon icon="solar:camera-outline" className="text-xl text-secondary-light" />
                                                    <span className="fw-semibold text-secondary-light">Upload</span>
                                                    <input
                                                        id={`section-image-${index}`}
                                                        type="file"
                                                        accept="image/*"
                                                        hidden
                                                        onChange={(e) =>
                                                            handleSectionImageChange(index, e.target.files[0])
                                                        }
                                                    />
                                                </label>
                                            )}
                                        </div>
                                    </div>

                                </div>
                            ))}



                            <div>
                                <label className='form-label fw-bold text-neutral-900'>
                                    Image
                                </label>
                                <div className='upload-image-wrapper'>
                                    {imagePreview ? (
                                        <div className='uploaded-img position-relative h-160-px w-100 border input-form-light radius-8 overflow-hidden border-dashed bg-neutral-50'>
                                            <button
                                                type='button'
                                                className='uploaded-img__remove position-absolute top-0 end-0 z-1 text-2xxl line-height-1 me-8 mt-8 d-flex bg-danger-600 w-40-px h-40-px justify-content-center align-items-center rounded-circle'
                                                onClick={handleRemoveImage}
                                            >
                                                <Icon
                                                    icon='radix-icons:cross-2'
                                                    className='text-2xl text-white'
                                                />
                                            </button>
                                            <img
                                                id='uploaded-img__preview'
                                                className='w-100 h-100 object-fit-cover'
                                                src={imagePreview}
                                                alt='Uploaded'
                                            />
                                        </div>
                                    ) : (
                                        <label
                                            className='upload-file h-160-px w-100 border input-form-light radius-8 overflow-hidden border-dashed bg-neutral-50 bg-hover-neutral-200 d-flex align-items-center flex-column justify-content-center gap-1'
                                            htmlFor='upload-file'
                                        >
                                            <iconify-icon
                                                icon='solar:camera-outline'
                                                className='text-xl text-secondary-light'
                                            ></iconify-icon>
                                            <span className='fw-semibold text-secondary-light'>
                                                Upload
                                            </span>
                                            <input
                                                id='upload-file'
                                                type='file'
                                                accept='image/*'
                                                hidden
                                                onChange={handleFileChange}
                                            />
                                        </label>
                                    )}
                                </div>
                            </div>

                            <button
                                type='submit'
                                className='btn btn-primary-600 radius-8'
                                disabled={creatingBlog}
                            >
                                {creatingBlog ? 'Creating...' : 'Submit'}
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default AddCaseStudy;